import React from 'react';

export const PaginationPreview = ({ component, onClick, isSelected }) => {
  const { commonAttrs, specificAttrs } = component;
  const { currentPage, totalPages, showPrevNext } = specificAttrs || {};
  const current = currentPage || 1;
  const total = totalPages || 10;
  
  const containerStyle = {
    padding: `${commonAttrs?.paddingTop || 16}px ${commonAttrs?.paddingRight || 16}px ${commonAttrs?.paddingBottom || 16}px ${commonAttrs?.paddingLeft || 16}px`,
    margin: `${commonAttrs?.marginTop || 8}px ${commonAttrs?.marginRight || 0}px ${commonAttrs?.marginBottom || 8}px ${commonAttrs?.marginLeft || 0}px`,
    width: commonAttrs?.width === 'auto' ? 'auto' : `${commonAttrs?.width || 100}%`,
    cursor: onClick ? 'pointer' : 'default',
    border: isSelected ? '2px solid #3B82F6' : '2px solid transparent',
    borderRadius: '4px'
  };
  
  return (
    <div style={containerStyle} onClick={onClick}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', fontSize: '14px' }}>
      {showPrevNext !== false && (
        <button style={{
          padding: '6px 12px',
          background: '#F3F4F6',
          border: '1px solid #D1D5DB',
          borderRadius: '6px',
          cursor: 'pointer'
        }}>
          ← Prev
        </button>
      )}
      {[...Array(Math.min(5, total))].map((_, idx) => {
        const pageNum = idx + 1;
        return (
          <button
            key={idx}
            style={{
              padding: '6px 12px',
              background: pageNum === current ? '#3B82F6' : '#FFFFFF',
              color: pageNum === current ? '#FFFFFF' : '#374151',
              border: '1px solid #D1D5DB',
              borderRadius: '6px',
              cursor: 'pointer',
              fontWeight: pageNum === current ? '600' : '400'
            }}
          >
            {pageNum}
          </button>
        );
      })}
      {total > 5 && <span style={{ color: '#9CA3AF' }}>...</span>}
      {showPrevNext !== false && (
        <button style={{
          padding: '6px 12px',
          background: '#F3F4F6',
          border: '1px solid #D1D5DB',
          borderRadius: '6px',
          cursor: 'pointer'
        }}>
          Next →
        </button>
      )}
      </div>
    </div>
  );
};
